import { render, staticRenderFns } from "./FitGapItem.vue?vue&type=template&id=a4b9958c&scoped=true"
import script from "./FitGapItem.vue?vue&type=script&lang=js"
export * from "./FitGapItem.vue?vue&type=script&lang=js"
import style0 from "./FitGapItem.vue?vue&type=style&index=0&id=a4b9958c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4b9958c",
  null
  
)

export default component.exports